import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import { jsonToXlsxBlob } from '../../utils/excelSheet';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import '../../CSS/Global.css';
import { BlobWriter, ZipWriter, TextReader } from '@zip.js/zip.js';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';

const ExportExpense = () => {

    const [isSpecificDateSelected, setIsSpecificDateSelected] = useState(false);
    const [fileFormat, setFileFormat] = useState("xlsx");
    const [password, setPassword] = useState("");
    const [invoiceData, setInvoiceData] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const url = API_BASE_URL
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""


    useEffect(() => {
        fetch(`${url}/api/expenses/all/${isLoggedIn.main_id}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then(res => res.json())
            .then(data => setInvoiceData(data))
            .catch(err => console.error("Failed to fetch invoices:", err));
    }, []);

    const handleRadioChange = (e) => {
        setIsSpecificDateSelected(e.target.value === 'specificDate');
    };

    // const handleExport = () => {
    //     if (!fileFormat) return alert("Please select a file format.");
    //     if (!password) return alert("Please enter a file password.");
    //     if (invoiceData.length === 0) return alert("No invoice data found.");

    //     let filteredData = [...invoiceData];

    //     if (isSpecificDateSelected) {
    //         if (!startDate || !endDate) return alert("Please select both start and end dates.");

    //         filteredData = invoiceData.filter(inv => {
    //             const invoiceDate = new Date(inv.invoice_date);
    //             const start = new Date(startDate);
    //             const end = new Date(endDate);
    //             return invoiceDate >= start && invoiceDate <= end;
    //         });

    //         if (filteredData.length === 0) {
    //             return alert("No invoices found in the selected date range.");
    //         }
    //     }

    //     const cleanedData = filteredData.map(inv => ({
    //         "Invoice Date": inv.invoice_date,
    //         "Order Number": inv.order_number,
    //         "Customer Name": inv.customer_name,
    //         "Due Date": inv.due_date,
    //         "Grand Total": inv.grand_total,
    //         "Pending": inv.pending,
    //         "Status": inv.pending === 0
    //             ? "Paid"
    //             : inv.due_date < new Date().toISOString().split("T")[0]
    //                 ? "Overdue"
    //                 : "Pending"
    //     }));

    //     const worksheet = XLSX.utils.json_to_sheet(cleanedData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

    //     const fileName = `invoices_${new Date().getTime()}.${fileFormat}`;
    //     XLSX.writeFile(workbook, fileName); // 👈 downloads directly (no zip)
    // };

    const handleExport = async () => {
        if (!fileFormat) return alert("Please select a file format.");
        // if (!password) return alert("Please enter a file password.");
        if (invoiceData.length === 0) return alert("No expense data found.");

        let filteredData = [...invoiceData];

        if (isSpecificDateSelected) {
            if (!startDate || !endDate) return alert("Please select both start and end dates.");

            filteredData = invoiceData.filter(inv => {
                const date = new Date(inv.date || inv.createdAt);
                const start = new Date(startDate);
                const end = new Date(endDate);
                return date >= start && date <= end;
            });

            if (filteredData.length === 0) return alert("No expenses found in selected date range.");
        }

        const cleanedData = filteredData.map(cust => ({
            "Date": cust.date || "",
            "Type": cust.expenseType || "",
            "Category": cust.category || "",
            "Receipt": cust.receipt
                ? cust.receipt.startsWith("https://")
                    ? cust.receipt
                    : cust.receipt
                : "",

            "Invoice Number": cust.invoiceNumber || "",
            "Notes": cust.notes || "",
            "Customer": cust.customer || "",

        }));

        const excelBlob = await jsonToXlsxBlob(cleanedData, "Expense");

        // Zip it with password
        // const zipWriter = new ZipWriter(new BlobWriter("application/zip"), {
        //     password,
        //     encryptionStrength: 3 // AES-256
        // });

        const fileName = `expense_${Date.now()}.xlsx`;

        if (password.trim()) {
            // If password is provided, create zip
            const zipWriter = new ZipWriter(new BlobWriter("application/zip"), {
                password,
                encryptionStrength: 3 // AES-256
            });

            await zipWriter.add(fileName, excelBlob.stream());
            const zipBlob = await zipWriter.close();

            const downloadUrl = URL.createObjectURL(zipBlob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = `${fileName}.zip`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(downloadUrl);
        } else {
            // No password, download plain file
            const downloadUrl = URL.createObjectURL(excelBlob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(downloadUrl);
        }
    };
    return (
        <>
            <div className="export-card">
                {/* Export Options */}
                <div className="export-radio">
                    <div className="export-radio-list">
                        <input type="radio" name="exportOption" value="allCustomers" checked={!isSpecificDateSelected} onChange={handleRadioChange} />
                        <label>All Expense</label>
                    </div>
                    <div className="export-radio-list">
                        <input type="radio" name="exportOption" value="specificDate" checked={isSpecificDateSelected} onChange={handleRadioChange} />
                        <label>Specific Date</label>
                    </div>
                </div>

                {isSpecificDateSelected && (
                    <div className="date-range">
                        <div className="date-range-list">
                            <label>Start Date:</label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="date-range-list">
                            <label>End Date:</label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>

                )}

                {/* Format selection */}
                <div className="export-file-type">
                    <p className="export-file-header">Select file format:</p>
                    <div className="export-file-options">
                        {["csv", "xls", "xlsx"].map(fmt => (
                            <div className="export-file-option-list" key={fmt}>
                                <input type="radio" name="fileFormat" id={fmt} value={fmt} onChange={e => setFileFormat(e.target.value)} />
                                <label htmlFor={fmt}>{fmt.toUpperCase()}</label>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Password input */}
                <div className="file-password">
                    <p className="file-password-header">File Password:</p>
                    <input type="password" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>

                {/* Export Buttons */}
                <div className="export-buttons">
                    <button className="export-button" type="button" onClick={handleExport}>Export</button>
                    <button className="export-cancel-button" type="button">Cancel</button>
                </div>
            </div>
        </>
    );
};

export default ExportExpense;
